import style from '@style/components/customHtml/Snackbar/style.css?inline'

export type SnackbarType = 'Success' | 'Error' | 'Info' | 'Warning'

export interface SnackbarElement extends HTMLElement {
  show(message: string, type?: SnackbarType): void
}

class Snackbar extends HTMLElement implements SnackbarElement {
  private snackbar: HTMLDivElement
  private messageContainer: HTMLDivElement
  private closeButton: HTMLButtonElement
  private icon: SVGSVGElement

  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
    this.shadowRoot!.innerHTML = `
      <style>
        ${style}
      </style>
      <div role="alert">
        <svg viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d=""/>
        </svg>
        <div></div>
        <button title="Fermer la notification">
          <svg viewBox="0 0 20 20">
            <path
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"
            />
          </svg>
        </button>
      </div>
    `
    this.snackbar = this.shadowRoot!.querySelector<HTMLDivElement>('div[role="alert"]')!
    this.messageContainer = this.shadowRoot!.querySelector<HTMLDivElement>('div div')!
    this.closeButton = this.shadowRoot!.querySelector('div button')!
    this.closeButton.addEventListener('click', () => this.hide())
    this.icon = this.shadowRoot!.querySelector('div svg')!
  }

  show(message: string, type: SnackbarType = 'Info'): void {
    this.messageContainer.innerHTML = message

    this.icon.querySelector('path')!.setAttribute('d', this.getIcon(type))

    this.snackbar.classList.add('show')

    setTimeout(() => this.hide(), 5000)
  }

  private hide(): void {
    const snackbar = this.shadowRoot!.querySelector('div')!
    snackbar.classList.remove('show')
    setTimeout(() => {
      this.messageContainer.innerHTML = ''
    }, 300)
  }

  private getIcon(type: SnackbarType): string {
    return {
      Success: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
      Error: 'M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z',
      Info: 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
      Warning:
        'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z',
    }[type]
  }
}

customElements.define('app-snackbar', Snackbar)
